import React, { useState } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Item,
  View,
  Key,
} from "@adobe/react-spectrum";
import UserInfo from "./UserInfo";
import Attachments from "./Attachments";
import ChatSummary from "./ChatSummary";

interface ChatInfoProps {
  isHistory: boolean;
  isLiveChat: boolean;
  activeChatId: string;
  isCall?: boolean;
}

const ChatInfo: React.FC<ChatInfoProps> = ({
  isHistory,
  isLiveChat,
  activeChatId,
  isCall = false,
}) => {
  type Tab = (typeof allTabs)[0];

  const allTabs = [
    {
      id: 1,
      name: "GenAI Summary",
      type: "chat",
      children: <ChatSummary activeChatId={activeChatId} />,
    },
    {
      id: 2,
      name: "Interaction Details",
      children: <UserInfo activeChatId={activeChatId} />,
    },
    { id: 3, name: "Attachments", children: <Attachments /> },
    {
      id: 4,
      name: "GenAI Summary",
      type: "call",
      children: <ChatSummary activeChatId={activeChatId} type="call" />,
    },
  ];

  const filteredTabs = allTabs.filter((tab) => {
    if (isCall) return tab.type === "call";

    const isCallSummary = tab.type === "call";
    const isChatSummary = tab.type === "chat";
    const isAttachments = tab.name === "Attachments";

    return (
      !isCallSummary &&
      !(isLiveChat && isChatSummary) &&
      !(isHistory && isAttachments)
    );
  });

  const getDefaultSelectedKey = () => {
    return isCall ? 4 : filteredTabs[0]?.id || 1;
  };

  let [tabId, setTabId] = useState<Key>(getDefaultSelectedKey());

  return (
    <View
      UNSAFE_style={{
        background: "#F8F8F8",
        height: "100%",
        width: "100%",
      }}
    >
      <Tabs
        aria-label="chat-tabs"
        items={filteredTabs}
        onSelectionChange={setTabId}
        defaultSelectedKey={getDefaultSelectedKey()}
        selectedKey={tabId}
      >
        <TabList UNSAFE_className="custom-tab-list">
          {(item: Tab) => <Item>{item.name}</Item>}
        </TabList>
        <TabPanels>{(item: Tab) => <Item>{item.children}</Item>}</TabPanels>
      </Tabs>
    </View>
  );
};

export default ChatInfo;
